import type { TranslationCardProps } from "@/components/screen/global-components/translation/TranslationCard";
import * as images from "@/components/images/Images_second";
import { CertificateSectionItemData } from "@/components/screen/global-components/certificate/CertificateSection";

const affiliateCard: TranslationCardProps = {
  iconId: "icon-certified-translation_58",
  title: "Affiliate Translate Program",
  buttonPrimaryLabel: "Join now",
  buttonPrimaryHref: "#",
  inheritsFrom: "What to expect:",
  features: [
    "Earn 25% revenue share for clients you refer to us",
    "Unlimited earning potential with no caps on the amount you can receive",
    "A unique tracking code ensures you get credit for every client referred",
    "Monitor your performance and detailed referral reports",
    "Monthly payouts via PayPal",
    "24/7 support available",
  ],
  notice:
    "Email our support team with your name, business, and interest to sign up and get your tracking link.We’ll get back to you within 24-hours or less.",
};

export const affiliateCertifiedItems: CertificateSectionItemData[] = [
  {
    id: "item-1",
    title: "Earn 25% revenue for every referral",
    description:
      "Sign up for the program by emailing our support team. Once approved, we will provide a unique tracking link that you can share with your audience. When a referred visitor places an order, you will receive credit in monthly payouts. You will receive up to 25% revenue share for the traffic you refer to us, with unlimited earning potential and regular monthly payouts via PayPal.",
  },
  {
    id: "item-2",
    title: "Passive income without the overhead",
    description:
      "When recommending trusted, high-quality human translations as part of your businesses to your audience that might need them, not only are you earning passive income, you’re improving their customer experience. It’s a great way to monetize your platform or website because you don’t need to do any customer service or deliver any of the work—we’ll do all of that for you.",
  },
  {
    id: "item-3",
    title: "Monitor your performance",
    description:
      "We will provide real-time tracking and detailed referral reports so you can see how your referrals are growing.",
  },
];

export const affiliateCertifiedData = {
  title: "Join our free partner program",
  description: null,
  items: affiliateCertifiedItems,
  card: affiliateCard,
};
